import { dashToCamelCase } from "@shared/camelCase";

type StringMap = {
  [key: string]: string;
}

export function data(element: HTMLElement): StringMap;
export function data(element: HTMLElement, propertyName: string, value?: string): string;
export function data(element: HTMLElement, propertyName?: string, value?: string): string | StringMap {
  // Get all
  if (typeof(propertyName) === 'undefined') {
    let result: StringMap = {};
    for (let key in element.dataset) {
      result[dashToCamelCase(key)] = element.dataset[key];
    }
    return result;
  }

  // Convert property
  propertyName = dashToCamelCase(propertyName);

  // Get single value
  if (typeof(value) === 'undefined') {
    return element.dataset[propertyName];
  }

  // Set value
  element.dataset[propertyName] = value;
  return element.dataset[propertyName];
}